module.exports = __webpack_public_path__ + "static/addleshaw-goddard--dark-4a4764bb742bdcaea366e29cb25f7c3e.png";